







import { Component, Vue } from "vue-property-decorator";

/**
 * Container for `DiamondButton` components
 **/
@Component
export default class DiamondBar extends Vue {}
